var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.724,
    height: 23.178,
    viewBox: "0 0 24.724 23.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat",
    transform: "translate(0 -16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56113",
    "data-name": "Group 56113",
    transform: "translate(0 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87860",
    "data-name": "Path 87860",
    d: "M12.314,16C5.524,16,0,20.874,0,26.865a10.125,10.125,0,0,0,2.824,6.927,4.4,4.4,0,0,1-1.164,4.15.725.725,0,0,0,.512,1.236,7.986,7.986,0,0,0,5.532-2.235,13.659,13.659,0,0,0,4.608.786c6.79,0,12.41-4.874,12.41-10.865S19.1,16,12.314,16Zm-5.7,13.038a2.173,2.173,0,1,1,2.173-2.173A2.175,2.175,0,0,1,6.616,29.038Zm5.795,0a2.173,2.173,0,1,1,2.173-2.173A2.175,2.175,0,0,1,12.41,29.038Zm5.795,0a2.173,2.173,0,1,1,2.173-2.173A2.175,2.175,0,0,1,18.2,29.038Z",
    transform: "translate(0 -16)",
    fill: "#444"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.52fa0f7fc2556893c8884135d2aada78.svg";
export { ForwardRef as ReactComponent };